export const TAG_TITLE_MAPPINGS = {
  LTO: "Limited-Time",
};

export const getDisplayTitle = (title) => {
  if (!title) return title;
  const upperTitle = title.toUpperCase();
  return TAG_TITLE_MAPPINGS[upperTitle] || title;
};